import { string } from "prop-types";

const AmsterdamNoord = ({ className, lakeClassName }) => (
  <>
    <path
      d="M694.986 114.966L735.412 104.163L747.851 62.8699H821.789L848.192 43.875L860.631 60.3923L873.07 49.6561H901.265L952.439 79.4203L960.035 71.8554H985.021V93.2783L979.556 98.7208H959.314L948.533 94.2529L931.534 111.183V118.203H941.899L953.924 106.228H985.021L1006.79 84.5489L1044.73 104.163L1067.12 95.9046H1098.63V107.467H1086.19L1076.24 101.686H1067.12L1048.05 109.944L1034.78 138.85L1009.9 151.238L985.85 172.71L981.944 186.337H940.241L921.997 226.392L941.899 242.083L931.948 256.123L937.753 261.904H921.997L915.777 268.098L927.802 278.421H933.242L930.29 295.764L922.826 302.371L902.095 290.809L896.804 276.332L866.436 275.944L848.192 297.416H839.9L819.997 269.337H805.9L790.144 251.168L783.924 257.362L773.094 246.584H694.986L652.901 258.138H617.242L652.901 227.358L670.995 186.337L665.754 177.665L678.193 152.064V136.372L694.986 114.966Z"
      fill="url(#paint6_linear_14735_232327)"
      fillOpacity="0.25"
      stroke="#4D4D4D"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeDasharray="4 4"
      className={className}
    />
    <path
      d="M694.986 114.967L654.559 83.1055H647.925L639.632 126.876L606.462 164.866L620.559 177.254L617.242 180.492L603.145 168.996L597.34 176.428L637.145 205.334H628.147L621.04 212.42L626.273 237.13L611.33 250.682L617.242 258.14L652.901 227.36L670.995 186.339L665.754 177.667L678.193 152.065V136.374L694.986 114.967Z"
      fill="url(#paint7_linear_14735_232327)"
      fillOpacity="0.25"
      stroke="#4D4D4D"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeDasharray="4 4"
      className={className}
    />
    <path
      d="M628.147 205.331L597.34 183.289L605.632 244.147L611.33 250.68L626.273 237.127L621.04 212.417L628.147 205.331Z"
      fill="url(#paint8_linear_14735_232327)"
      fillOpacity="0.25"
      stroke="#4D4D4D"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeDasharray="4 4"
      className={className}
    />
    <path
      d="M923.135 129.352L885.926 158.257V166.268L929.031 147.81L923.135 129.352Z"
      stroke="#4D4D4D"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeDasharray="4 4"
      className={lakeClassName}
    />
    <path
      d="M647.926 83.1042L586.146 46.3531H540.346L532.244 38.0944L525.61 24.0547H497.265L480 51.3083L487.256 72.0623L480 86.9857L497.415 94.2533H507.565L508.195 102.512L533.073 120.681L539.707 113.248L545.512 118.203L538.878 126.462L557.122 139.676L569.561 137.198L574.536 142.154L566.244 152.89L581.17 163.626L580.341 176.84L597.341 176.427L603.146 168.994L591.121 157.019L594.439 153.716L606.463 164.865L631.681 135.984L594.181 98.6387L599.414 93.4275L636.632 130.311L639.633 126.875L647.926 83.1042Z"
      fill="url(#paint9_linear_14735_232327)"
      fillOpacity="0.25"
      stroke="#4D4D4D"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeDasharray="4 4"
      className={className}
    />
  </>
);

AmsterdamNoord.propTypes = {
  className: string,
  lakeClassName: string,
};

export default AmsterdamNoord;
